import {
	GET_FILTERED_ORDERS_SUCCESS,
	GET_INCIDENCES_LIST_SUCCESS,
	GET_OPENED_EXPEDITION_ORDERS_SUCCESS,
	GET_OPENED_VERIFICATION_ORDERS_SUCCESS,
	GET_OPEPENED_ORDERS_SUCCESS,
	GET_ORDER_DETAIL_BY_ID_SUCCESS,
	GET_ORDER_DETAIL_SUCCESS,
	GET_ORDER_LIST_SUCCESS,
	GET_PENDING_INVOICE_ORDERS_SUCCESS,
} from 'store/orders/actionTypes'
import {
	DELETE_MODIFIED_BLUEPRINT,
	GET_FILTERED_OFFERS_SUCCESS,
	GET_OFFER_DETAIL_SUCCESS,
	GET_OFFER_LIST_SUCCESS,
} from 'store/offers/actionTypes'
import {
	GET_FILTERED_PRODUCTIONS_SUCCESS,
	GET_FILTERED_PRODUCTION_WITH_PARTS_INVOICING_SUCCESS,
	GET_FILTERED_PRODUCTION_WITH_PARTS_INVOICING_TO_EXPORT_SUCCESS,
	GET_PRODUCTIONS_BY_TRACKING_SUCCESS,
	GET_PRODUCTIONS_LIST_FROM_ORDER_ID_SUCCESS,
	GET_PRODUCTIONS_PICKED_UP_BY_COURIER_SUCCESS,
	GET_PRODUCTION_DETAIL_SUCCESS,
	GET_PRODUCTION_ITEMS_BY_ORDER_ID_SUCCESS,
	GET_PRODUCTION_ITEMS_BY_PART_ID_SUCCESS,
	GET_PRODUCTION_LIST_BY_SUPPLIER_SUCCESS,
	GET_PRODUCTION_LIST_SUCCESS,
	LAUNCH_PRODUCTION_SUCCESS,
} from 'store/productions/actionTypes'
import {
	GET_OFFER_FILTERED_PARTS_SUCCESS,
	GET_ORDER_FILTERED_PARTS_SUCCESS,
	GET_SIMILAR_PARTS_DETAIL_SUCCESS,
} from 'store/parts/actionTypes'
import {
	GET_QUOTE_DETAIL_SUCCESS,
	GET_QUOTE_LIST_SUCCESS,
	GET_SIMILAR_QUOTE_PARTS_SUCCESS,
} from 'store/quotes/actionTypes'
import {
	DELETE_COMPLETE_PRODUCTION_FILE,
	DELETE_COMPLETE_PRODUCTION_FILE_FAIL,
	DELETE_COMPLETE_PRODUCTION_FILE_SUCCESS,
	DELETE_MODIFIED_BLUEPRINTS_FAIL,
	DELETE_MODIFIED_BLUEPRINTS_SUCCESS,
	DELETE_OLD_PART_FILES,
	DELETE_OLD_PART_FILES_FAIL,
	DELETE_OLD_PART_FILES_SUCCESS,
	DOWNLOAD_PART_LIST_IMAGES_IN_BASE64,
	DOWNLOAD_PART_LIST_IMAGES_IN_BASE64_FAIL,
	DOWNLOAD_PART_LIST_IMAGES_IN_BASE64_SUCCESS,
	GET_ALL_ORDER_SHIPMENT_FILES,
	GET_ALL_ORDER_SHIPMENT_FILES_FAIL,
	GET_ALL_ORDER_SHIPMENT_FILES_SUCCESS,
	GET_COMPLETE_PRODUCTION_FILES,
	GET_COMPLETE_PRODUCTION_FILES_FAIL,
	GET_COMPLETE_PRODUCTION_FILES_SUCCESS,
	GET_DELIVERY_RECEIPT_BY_ORDER_ID,
	GET_DELIVERY_RECEIPT_BY_ORDER_ID_FAIL,
	GET_DELIVERY_RECEIPT_BY_ORDER_ID_SUCCESS,
	GET_OFFICIAL_ORDER_BY_ORDER_ID,
	GET_OFFICIAL_ORDER_BY_ORDER_ID_FAIL,
	GET_OFFICIAL_ORDER_BY_ORDER_ID_SUCCESS,
	GET_MANAGER_TASK_IMAGES_BY_NOTIFICATION_ID,
	GET_MANAGER_TASK_IMAGES_BY_NOTIFICATION_ID_FAIL,
	GET_MANAGER_TASK_IMAGES_BY_NOTIFICATION_ID_SUCCESS,
	GET_PARTS_FILES,
	GET_PARTS_FILES_FAIL,
	GET_PARTS_FILES_SUCCESS,
	GET_PART_LIST_BLUEPRINTS_AND_STP,
	GET_PART_LIST_BLUEPRINTS_AND_STP_FAIL,
	GET_PART_LIST_BLUEPRINTS_AND_STP_SUCCESS,
	GET_PART_LIST_IMAGES,
	GET_PART_LIST_IMAGES_FAIL,
	GET_PART_LIST_IMAGES_SUCCESS,
	GET_PRODUCTION_CHAT_IMAGES,
	GET_PRODUCTION_CHAT_IMAGES_FAIL,
	GET_PRODUCTION_CHAT_IMAGES_SUCCESS,
	GET_QUALITY_VERIFICATION_IMAGES,
	GET_QUALITY_VERIFICATION_IMAGES_FAIL,
	GET_QUALITY_VERIFICATION_IMAGES_SUCCESS,
	GET_QUOTE_CHAT_IMAGES,
	GET_QUOTE_CHAT_IMAGES_FAIL,
	GET_QUOTE_CHAT_IMAGES_SUCCESS,
	GET_RESOLUTIONS_IMAGES_BY_INCIDENCE_ID,
	GET_RESOLUTIONS_IMAGES_BY_INCIDENCE_ID_FAIL,
	GET_RESOLUTIONS_IMAGES_BY_INCIDENCE_ID_SUCCESS,
	GET_SUPPLIER_QUOTATION_FILES_BY_OFFER_ID,
	GET_SUPPLIER_QUOTATION_FILES_BY_OFFER_ID_FAIL,
	GET_SUPPLIER_QUOTATION_FILES_BY_OFFER_ID_SUCCESS,
	RESET_VALUES_OF_UPLOAD_QUALITY_VERIFICATION_IMAGES,
	UPLOAD_COMPLETE_PRODUCTION_FILES,
	UPLOAD_COMPLETE_PRODUCTION_FILES_FAIL,
	UPLOAD_COMPLETE_PRODUCTION_FILES_SUCCESS,
	UPLOAD_MANAGER_TASK_IMAGE,
	UPLOAD_MANAGER_TASK_IMAGE_FAIL,
	UPLOAD_MANAGER_TASK_IMAGE_SUCCESS,
	UPLOAD_ORDER_DELIVERY_NOTE,
	UPLOAD_ORDER_DELIVERY_NOTE_FAIL,
	UPLOAD_ORDER_DELIVERY_NOTE_SUCCESS,
	UPLOAD_ORDER_SHIPMENT_FILES,
	UPLOAD_ORDER_SHIPMENT_FILES_FAIL,
	UPLOAD_ORDER_SHIPMENT_FILES_SUCCESS,
	UPLOAD_PART_FILES,
	UPLOAD_PART_FILES_FAIL,
	UPLOAD_PART_FILES_SUCCESS,
	UPLOAD_PART_IMAGE,
	UPLOAD_PART_IMAGE_FAIL,
	UPLOAD_PART_IMAGE_SUCCESS,
	UPLOAD_PRODUCTION_CHAT_IMAGE,
	UPLOAD_PRODUCTION_CHAT_IMAGE_FAIL,
	UPLOAD_PRODUCTION_CHAT_IMAGE_SUCCESS,
	UPLOAD_PROFILE_IMAGE,
	UPLOAD_PROFILE_IMAGE_FAIL,
	UPLOAD_PROFILE_IMAGE_SUCCESS,
	UPLOAD_QUALITY_VERIFICATION_IMAGES,
	UPLOAD_QUALITY_VERIFICATION_IMAGES_FAIL,
	UPLOAD_QUALITY_VERIFICATION_IMAGES_SUCCESS,
	UPLOAD_QUOTE_CHAT_IMAGE,
	UPLOAD_QUOTE_CHAT_IMAGE_FAIL,
	UPLOAD_QUOTE_CHAT_IMAGE_SUCCESS,
	UPLOAD_REPLACE_PART_FILES,
	UPLOAD_REPLACE_PART_FILES_FAIL,
	UPLOAD_REPLACE_PART_FILES_SUCCESS,
	UPLOAD_RESOLUTION_IMAGE,
	UPLOAD_RESOLUTION_IMAGE_FAIL,
	UPLOAD_RESOLUTION_IMAGE_SUCCESS,
	UPLOAD_TO_CAD,
	UPLOAD_TO_CAD_FAIL,
	UPLOAD_TO_CAD_SUCCESS,
} from './actionTypes'

/**
 * From an IPart-shaped object (or parts-finder shape with `signedImageUrl`),
 * returns `{ id, fileLinks }` or null if no file data is present.
 * @param {any} part
 */
const extractFilesFromPart = (part) => {
	if (part == null) return null
	const id = part.id ?? part.partId
	if (id == null) return null
	const fileLinks = { ...(part.fileLinks || {}) }
	if (part.signedImageUrl != null && fileLinks.thumbnail == null) {
		fileLinks.thumbnail = part.signedImageUrl
	}
	if (Object.keys(fileLinks).length === 0) return null
	return { id, fileLinks }
}

const isPlainObject = (v) => v != null && typeof v === 'object' && !Array.isArray(v) && Object.getPrototypeOf(v) === Object.prototype

const probeHasFiles = (node) => {
	if (Array.isArray(node)) return probeHasFiles(node[0])
	if (!isPlainObject(node)) return false
	if ('fileLinks' in node || 'signedImageUrl' in node) return true
	return Object.values(node).some(probeHasFiles)
}

/** Recursively collects all part file data from a payload. For arrays, probes the first item and skips the whole array if no file data is found there. */
const collectParts = (node, results = []) => {
	if (Array.isArray(node)) {
		if (!probeHasFiles(node[0])) return results
		for (const item of node) collectParts(item, results)
		return results
	}
	if (!isPlainObject(node)) return results
	const extracted = extractFilesFromPart(node)
	if (extracted) results.push(extracted)
	for (const val of Object.values(node)) collectParts(val, results)
	return results
}

/**
 * Adds new parts into existing parts list, merging fileLinks per partId.
 * New fileLinks fields override old ones; old fields are preserved if not in new.
 * @param {any[]} existingParts
 * @param {any[]} newParts
 */
const mergePartsFiles = (existingParts, newParts) => {
	const result = [...existingParts]
	for (const newPart of newParts) {
		if (newPart?.id == null) continue
		const idx = result.findIndex(p => p.id === newPart.id)
		if (idx === -1) {
			result.push(newPart)
		} else {
			result[idx] = {
				...result[idx],
				...newPart,
				fileLinks: { ...result[idx].fileLinks, ...newPart.fileLinks },
			}
		}
	}
	return result
}

/** Returns a new state with `newParts` merged into `partsFiles`. No-op if newParts is empty. */
const withPartsFilesMerged = (state, newParts) => {
	if (newParts.length === 0) return state
	return {
		...state,
		partsFiles: {
			...(state.partsFiles || {}),
			parts: mergePartsFiles(state.partsFiles?.parts || [], newParts),
		},
	}
}


/** @type {StoreState["CloudStorage"]} */
const INIT_STATE = {
	isLoading: false,
	isDeleteBlueprintsCompleted: null,
	error: null,
	images: [],
	chatImages: [],
	partsBlueprintsAndStp: [],
	partsFiles: { parts: null },
	productionChatImages: [],
	productionFiles: [],
	uploadCompleteProductionFilesSuccess: false,
	uploadImagesSuccess: false,
	imagesInBase64: [],
	deliveryNote: null,
	orderShipmentFiles: [],
	qualityVerficationImages: [],
	deleteCompleteProductionFilesSuccess: null,
	isLoadingGetQualityVerificationImages: false,
	dontShowModalAutomatic: null,
	resolutionsImages: null,
	managerTaskImages: null,
	isLoadingManagerTaskImages: false,

	uploadPartFilesState: {
		status: undefined,
		response: undefined,
		error: undefined,
	},
	uploadPartFilesStateByPartIdState: {},
	uploadReplacePartFilesState: {
		status: undefined,
		response: undefined,
		error: undefined,
	},
	uploadToCadState: {
		status: undefined,
		response: undefined,
		error: undefined,
	},
	deleteOldPartFilesState: {
		status: undefined,
		response: undefined,
		error: undefined,
	},
	deliveryReceiptOrder: null,
	officialOrderFile: null,
	isUploadingReplaceBlueprint: false,
	uploadingReplaceBlueprintError: false,
	uploadingReplaceBlueprintSuccess: false,
	isLoadingUploadQualityVerificationImages: null
}

const CloudStorage = (state = INIT_STATE, action) => {
	switch (action.type) {

		case RESET_VALUES_OF_UPLOAD_QUALITY_VERIFICATION_IMAGES:
			return {
				...state,
				isLoadingUploadQualityVerificationImages: null
			}

		case UPLOAD_REPLACE_PART_FILES:
			return {
				...state,
				isUploadingReplaceBlueprint: true,
				uploadingReplaceBlueprintError: false,
				uploadingReplaceBlueprintSuccess: false,
			}
		case UPLOAD_REPLACE_PART_FILES_SUCCESS:
			return {
				...state,
				isUploadingReplaceBlueprint: false,
				uploadingReplaceBlueprintError: false,
				uploadingReplaceBlueprintSuccess: true,
			}
		case UPLOAD_REPLACE_PART_FILES_FAIL:
			return {
				...state,
				isUploadingReplaceBlueprint: false,
				uploadingReplaceBlueprintError: true,
				uploadingReplaceBlueprintSuccess: false,
			}

		case UPLOAD_MANAGER_TASK_IMAGE:
			return {
				...state,
				isLoadingUploadManagerTaskImages: true,
			}

		case UPLOAD_MANAGER_TASK_IMAGE_SUCCESS:
			return {
				...state,
				isLoadingUploadManagerTaskImages: false,
			}

		case UPLOAD_MANAGER_TASK_IMAGE_FAIL:
			return {
				...state,
				isLoadingUploadManagerTaskImages: false,
				error: action.payload.error,
			}
		case GET_MANAGER_TASK_IMAGES_BY_NOTIFICATION_ID:
			return {
				...state,
				isLoadingManagerTaskImages: true,
			}

		case GET_MANAGER_TASK_IMAGES_BY_NOTIFICATION_ID_SUCCESS:
			return {
				...state,
				isLoadingManagerTaskImages: false,
				managerTaskImages: action.payload.response.managerTaskImages,
			}

		case GET_MANAGER_TASK_IMAGES_BY_NOTIFICATION_ID_FAIL:
			return {
				...state,
				isLoadingManagerTaskImages: false,
				error: action.payload.error,
			}

		case UPLOAD_RESOLUTION_IMAGE:
			return {
				...state,
				isLoading: true,
			}
		case UPLOAD_RESOLUTION_IMAGE_SUCCESS:
			return {
				...state,
				isLoading: false,
			}
		case UPLOAD_RESOLUTION_IMAGE_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}

		case GET_RESOLUTIONS_IMAGES_BY_INCIDENCE_ID:
			return {
				...state,
				isLoading: true,
			}

		case GET_RESOLUTIONS_IMAGES_BY_INCIDENCE_ID_SUCCESS:
			return {
				...state,
				isLoading: false,
				resolutionsImages: action.payload.response.resolutionsImages,
			}

		case GET_RESOLUTIONS_IMAGES_BY_INCIDENCE_ID_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}

		case GET_OFFICIAL_ORDER_BY_ORDER_ID:
			return {
				...state,
				isLoading: true,
				officialOrderFile: null,
			}

		case GET_OFFICIAL_ORDER_BY_ORDER_ID_SUCCESS:
			return {
				...state,
				isLoading: false,
				officialOrderFile: action.payload.response.officialOrderFile,
			}

		case GET_OFFICIAL_ORDER_BY_ORDER_ID_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}

		case GET_DELIVERY_RECEIPT_BY_ORDER_ID:
			return {
				...state,
				isLoading: true,
			}

		case GET_DELIVERY_RECEIPT_BY_ORDER_ID_SUCCESS:
			return {
				...state,
				isLoading: false,
				deliveryReceiptOrder: action.payload.response.deliveryReceiptData,
			}

		case GET_DELIVERY_RECEIPT_BY_ORDER_ID_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}

		case UPLOAD_PROFILE_IMAGE:
			return {
				...state,
				isLoading: true,
			}
		case UPLOAD_PROFILE_IMAGE_SUCCESS:
			return {
				...state,
				isLoading: false,
				uploadImagesSuccess: true,
			}
		case UPLOAD_PROFILE_IMAGE_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}



		case GET_SUPPLIER_QUOTATION_FILES_BY_OFFER_ID:
			return {
				...state,
				error: null,
			}
		case GET_SUPPLIER_QUOTATION_FILES_BY_OFFER_ID_SUCCESS:
			return {
				...state,
			}
		case GET_SUPPLIER_QUOTATION_FILES_BY_OFFER_ID_FAIL:
			return {
				...state,
				error: action.payload.error.response.statusText,
			}
		case GET_PART_LIST_IMAGES:
			return {
				...state,
			}
		case GET_PART_LIST_IMAGES_SUCCESS:
			return {
				...state,
				images: action.payload.response.images,
			}
		case GET_PART_LIST_IMAGES_FAIL:
			return {
				...state,
				error: action.payload.error,
			}
		case UPLOAD_PART_IMAGE:
			return {
				...state,
			}
		case UPLOAD_PART_IMAGE_SUCCESS:
			return {
				...state,
			}
		case UPLOAD_PART_IMAGE_FAIL:
			return {
				...state,
				error: action.payload.error,
			}

		// ------------ UPLOAD_PART_FILES
		case UPLOAD_PART_FILES:
			// If metadata id is provided (partId), we save status+result+error by partId.
			// Otherwise, we would not be able to handle updating multiple parts at the same time correctly.
			if (action.metadata.id != null) {
				state.uploadPartFilesStateByPartIdState = {
					...state.uploadPartFilesStateByPartIdState,
					[action.metadata.id]: {
						status: 'fetching',
						error: undefined,
					},
				}
			}
			return {
				...state,
				uploadPartFilesState: {
					status: 'fetching',
					response: undefined,
					error: undefined,
				},
			}
		case UPLOAD_PART_FILES_SUCCESS:
			// If metadata id is provided (partId), we save status+result+error by partId.
			// Otherwise, we would not be able to handle updating multiple parts at the same time correctly.
			if (action.metadata.id != null) {
				state.uploadPartFilesStateByPartIdState = {
					...state.uploadPartFilesStateByPartIdState,
					[action.metadata.id]: {
						status: 'finished',
						error: undefined,
					},
				}
			}
			return {
				...state,
				uploadPartFilesState: {
					status: 'finished',
					response: action.payload.response,
					error: undefined,
				},
			}
		case UPLOAD_PART_FILES_FAIL:
			// If metadata id is provided (partId), we save status+result+error by partId.
			// Otherwise, we would not be able to handle updating multiple parts at the same time correctly.
			if (action.metadata.id != null) {
				state.uploadPartFilesStateByPartIdState = {
					...state.uploadPartFilesStateByPartIdState,
					[action.metadata.id]: {
						status: 'finished',
						error: action.payload.error,
					},
				}
			}
			return {
				...state,
				uploadPartFilesState: {
					status: 'finished',
					response: undefined,
					error: action.payload.error,
				},
			}

		// ------------ UPLOAD_TO_CAD
		case UPLOAD_TO_CAD:
			return {
				...state,
				uploadToCadState: {
					status: 'fetching',
					response: undefined,
					error: undefined,
				},
			}
		case UPLOAD_TO_CAD_SUCCESS:
			return {
				...state,
				uploadToCadState: {
					status: 'finished',
					response: action.payload.response,
					error: undefined,
				},
			}
		case UPLOAD_TO_CAD_FAIL:
			return {
				...state,
				uploadToCadState: {
					status: 'finished',
					response: undefined,
					error: action.payload.error,
				},
			}

		// ------------ DELETE_OLD_PART_FILES
		case DELETE_OLD_PART_FILES:
			return {
				...state,
				deleteOldPartFilesState: {
					status: 'fetching',
					response: undefined,
					error: undefined,
				},
			}
		case DELETE_OLD_PART_FILES_SUCCESS:
			return {
				...state,
				deleteOldPartFilesState: {
					status: 'finished',
					response: action.payload.response,
					error: undefined,
				},
			}
		case DELETE_OLD_PART_FILES_FAIL:
			return {
				...state,
				deleteOldPartFilesState: {
					status: 'finished',
					response: undefined,
					error: action.payload.error,
				},
			}

		case GET_PART_LIST_BLUEPRINTS_AND_STP:
			return {
				...state,
			}
		case GET_PART_LIST_BLUEPRINTS_AND_STP_SUCCESS:
			return {
				...state,
				partsBlueprintsAndStp: action.payload.response,
			}
		case GET_PART_LIST_BLUEPRINTS_AND_STP_FAIL:
			return {
				...state,
				error: action.payload.error,
			}
		case GET_QUOTE_CHAT_IMAGES:
			return {
				...state,
			}
		case GET_QUOTE_CHAT_IMAGES_SUCCESS:
			return {
				...state,
				chatImages: action.payload.response,
			}
		case GET_QUOTE_CHAT_IMAGES_FAIL:
			return {
				...state,
				error: action.payload.error,
			}
		case UPLOAD_QUOTE_CHAT_IMAGE:
			return {
				...state,
			}
		case UPLOAD_QUOTE_CHAT_IMAGE_SUCCESS:
			return {
				...state,
			}
		case UPLOAD_QUOTE_CHAT_IMAGE_FAIL:
			return {
				...state,
				error: action.payload.error,
			}
		case GET_PARTS_FILES:
			return {
				...state,
			}
		case GET_FILTERED_OFFERS_SUCCESS:
		case GET_FILTERED_ORDERS_SUCCESS:
		case GET_FILTERED_PRODUCTION_WITH_PARTS_INVOICING_SUCCESS:
		case GET_FILTERED_PRODUCTION_WITH_PARTS_INVOICING_TO_EXPORT_SUCCESS:
		case GET_FILTERED_PRODUCTIONS_SUCCESS:
		case GET_INCIDENCES_LIST_SUCCESS:
		case GET_OFFER_DETAIL_SUCCESS:
		case GET_OFFER_FILTERED_PARTS_SUCCESS:
		case GET_OFFER_LIST_SUCCESS:
		case GET_OPENED_EXPEDITION_ORDERS_SUCCESS:
		case GET_OPENED_VERIFICATION_ORDERS_SUCCESS:
		case GET_OPEPENED_ORDERS_SUCCESS:
		case GET_ORDER_DETAIL_BY_ID_SUCCESS:
		case GET_ORDER_DETAIL_SUCCESS:
		case GET_ORDER_FILTERED_PARTS_SUCCESS:
		case GET_ORDER_LIST_SUCCESS:
		case GET_PARTS_FILES_SUCCESS:
		case GET_PENDING_INVOICE_ORDERS_SUCCESS:
		case GET_PRODUCTION_DETAIL_SUCCESS:
		case GET_PRODUCTION_ITEMS_BY_ORDER_ID_SUCCESS:
		case GET_PRODUCTION_ITEMS_BY_PART_ID_SUCCESS:
		case GET_PRODUCTION_LIST_BY_SUPPLIER_SUCCESS:
		case GET_PRODUCTION_LIST_SUCCESS:
		case GET_PRODUCTIONS_BY_TRACKING_SUCCESS:
		case GET_PRODUCTIONS_LIST_FROM_ORDER_ID_SUCCESS:
		case GET_PRODUCTIONS_PICKED_UP_BY_COURIER_SUCCESS:
		case GET_QUOTE_DETAIL_SUCCESS:
		case GET_QUOTE_LIST_SUCCESS:
		case GET_SIMILAR_PARTS_DETAIL_SUCCESS:
		case GET_SIMILAR_QUOTE_PARTS_SUCCESS:
		case LAUNCH_PRODUCTION_SUCCESS:
			return withPartsFilesMerged(state, collectParts(action.payload))
		case GET_PARTS_FILES_FAIL:
			return {
				...state,
				error: action.payload.error,
			}
		case GET_PRODUCTION_CHAT_IMAGES:
			return {
				...state,
			}
		case GET_PRODUCTION_CHAT_IMAGES_SUCCESS:
			return {
				...state,
				productionChatImages: action.payload.response,
			}
		case GET_PRODUCTION_CHAT_IMAGES_FAIL:
			return {
				...state,
				error: action.payload.error,
			}
		case UPLOAD_PRODUCTION_CHAT_IMAGE:
			return {
				...state,
			}
		case UPLOAD_PRODUCTION_CHAT_IMAGE_SUCCESS:
			return {
				...state,
			}
		case UPLOAD_PRODUCTION_CHAT_IMAGE_FAIL:
			return {
				...state,
				error: action.payload.error,
			}

		case UPLOAD_COMPLETE_PRODUCTION_FILES:
			return {
				...state,
				uploadCompleteProductionFilesSuccess: null,
				isLoading: true,
			}
		case UPLOAD_COMPLETE_PRODUCTION_FILES_SUCCESS:
			return {
				...state,
				uploadCompleteProductionFilesSuccess: true,
				isLoading: false,
			}
		case UPLOAD_COMPLETE_PRODUCTION_FILES_FAIL:
			return {
				...state,
				uploadCompleteProductionFilesSuccess: false,
				isLoading: false,
				error: action.payload.error,
			}
		case GET_COMPLETE_PRODUCTION_FILES:
			return {
				...state,
				isLoading: true,
				productionFiles: null,
			}
		case GET_COMPLETE_PRODUCTION_FILES_SUCCESS:
			return {
				...state,
				isLoading: false,
				productionFiles: action.payload.response,
			}
		case GET_COMPLETE_PRODUCTION_FILES_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}
		case DELETE_MODIFIED_BLUEPRINT:
			return {
				...state,
				isLoading: true,
				isDeleteBlueprintsCompleted: null,
			}
		case DELETE_MODIFIED_BLUEPRINTS_SUCCESS:
			return {
				...state,
				isLoading: false,
				isDeleteBlueprintsCompleted: true,
			}
		case DELETE_MODIFIED_BLUEPRINTS_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error.message,
				isDeleteBlueprintsCompleted: false,
			}
		case UPLOAD_ORDER_SHIPMENT_FILES:
			return {
				...state,
				isLoading: true,
			}
		case UPLOAD_ORDER_SHIPMENT_FILES_SUCCESS:
			return {
				...state,
				isLoading: false,
			}
		case UPLOAD_ORDER_SHIPMENT_FILES_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}
		case UPLOAD_QUALITY_VERIFICATION_IMAGES:
			return {
				...state,
				isLoading: true,
				isLoadingUploadQualityVerificationImages: true,
				images: [],
			}
		case UPLOAD_QUALITY_VERIFICATION_IMAGES_SUCCESS:
			return {
				...state,
				isLoading: false,
				isLoadingUploadQualityVerificationImages: false,
				images: action.payload.response.uploadedIn,
			}
		case UPLOAD_QUALITY_VERIFICATION_IMAGES_FAIL:
			return {
				...state,
				isLoading: false,
				isLoadingUploadQualityVerificationImages: false,
				error: action.payload.error,
			}
		case DOWNLOAD_PART_LIST_IMAGES_IN_BASE64:
			return {
				...state,
				isLoading: true,
				imagesInBase64: [],
			}
		case DOWNLOAD_PART_LIST_IMAGES_IN_BASE64_SUCCESS:
			return {
				...state,
				isLoading: false,
				imagesInBase64: action.payload.response,
			}
		case DOWNLOAD_PART_LIST_IMAGES_IN_BASE64_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}

		case UPLOAD_ORDER_DELIVERY_NOTE:
			return {
				...state,
				isLoading: true,
				deliveryNote: null,
			}
		case UPLOAD_ORDER_DELIVERY_NOTE_SUCCESS:
			return {
				...state,
				isLoading: false,
				deliveryNote: action.payload.response.uploadedIn,
			}
		case UPLOAD_ORDER_DELIVERY_NOTE_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			}
		case GET_QUALITY_VERIFICATION_IMAGES:

			return {
				...state,
				isLoadingGetQualityVerificationImages: true,
				dontShowModalAutomatic: action.payload.dontShowModalAutomatic,
				qualityVerficationImages: [],
			}
		case GET_QUALITY_VERIFICATION_IMAGES_SUCCESS:

			return {
				...state,
				isLoadingGetQualityVerificationImages: false,
				qualityVerficationImages: action.payload.response.images,
				dontShowModalAutomatic: action.payload.dontShowModalAutomatic,
			}
		case GET_QUALITY_VERIFICATION_IMAGES_FAIL:
			return {
				...state,
				isLoadingGetQualityVerificationImages: false,
				error: action.payload.error.message,
			}
		case GET_ALL_ORDER_SHIPMENT_FILES:
			return {
				...state,
				isLoading: true,
				orderShipmentFiles: [],
			}
		case GET_ALL_ORDER_SHIPMENT_FILES_SUCCESS:
			return {
				...state,
				isLoading: false,
				orderShipmentFiles: action.payload.response,
			}
		case GET_ALL_ORDER_SHIPMENT_FILES_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error.message,
			}

		case DELETE_COMPLETE_PRODUCTION_FILE:
			return {
				...state,
				deleteCompleteProductionFilesSuccess: null,
				isLoading: true,
			}
		case DELETE_COMPLETE_PRODUCTION_FILE_SUCCESS:
			return {
				...state,
				deleteCompleteProductionFilesSuccess: true,
				isLoading: false,
			}
		case DELETE_COMPLETE_PRODUCTION_FILE_FAIL:
			return {
				...state,
				deleteCompleteProductionFilesSuccess: false,
				isLoading: false,
				error: action.payload.error,
			}

		default:
			return state
	}

}
export default CloudStorage
